import { StyleValue } from 'vue'
import type { FilterKey } from '~/composables/useNetworkSVG'
import {
  CSSVariableCategory,
  CSSVariableEquipmentStatus,
  CSSVariableEquipmentType,
  CSSVariableNetworkState,
  CSSVariableOfflineRange,
  CSSVariableProject,
  CSSVariableTextOpacityCategory,
  CSSVariableTextOpacityEquipmentStatus,
  CSSVariableTextOpacityEquipmentType,
  CSSVariableTextOpacityNetworkState,
  CSSVariableTextOpacityOfflineRange,
  CSSVariableTextOpacityProject,
  CSSVariableTextOpacityVoltage,
  CSSVariableVoltage,
} from '~/composables/coloring/helpers'

export enum FileDataFormatEnum {
  NEPTUN = 'neptun',
  NEPTUN_PLUS = 'neptun_plus',
  TBT = 'tbt',
}
export enum SwitchingEventsEnum {
  /**
   * Betriebsmittel mit Schaltungen deren Start/Ende innerhalb des Datums liegen
   */
  IN_RANGE_SWITCHING = 'in_range_switching',
  /**
   * Betriebsmittel die nicht verfügbar sind weil
   * - vorher eine Außerbetriebnahme stattfand, oder eine Inbetriebnahme noch ansteht
   * - eine Freischaltung, Schutzschaltung oder US-Betrieb stattfindet
   */
  IN_RANGE_OFFLINE = 'in_range_offline',
}

export enum FileEncodingEnum {
  TBT_XLS = 'xls',
  NEPTUN_WEST_EUROPE = 'ISO-8859-15',
  NEPTUN_UNICODE = 'UTF-8',
}

export const TableHighlightClass = 'bg-primary-lighten-2'

export const CommonIcons = {
  SwitchingPremises: 'mdi-tune',
  Report: 'mdi-file-pdf-box',
  CompareActivity: 'mdi-ab-testing',
  NetworkSVG: '$NetDiagram',
} as const

export type LegendEntry = {
  label: string
  style?: StyleValue
  cssClass: string[]
}

export type LegendEntryGantt = LegendEntry & {
  width?: `width: ${number}px`
}

export type LegendEntrySVG = LegendEntry & {
  filterKey: FilterKey
}

export type LegendGroup<T extends LegendEntry = LegendEntry> = {
  label: string
  items: T[]
}

/**
 * Types for typesafe style generation - Take care changing structure :)
 */
type CSSPropCategory = ReturnType<typeof CSSVariableCategory>
type CSSPropProjectGantt = ReturnType<typeof CSSVariableProject>
type CSSPropVoltageGantt = ReturnType<typeof CSSVariableVoltage>
type CSSPropOfflineRange = ReturnType<typeof CSSVariableOfflineRange>
type CSSPropEquipmentType = ReturnType<typeof CSSVariableEquipmentType>
type CSSPropNetworkState = ReturnType<typeof CSSVariableNetworkState>
type CSSPropEquipmentStatus = ReturnType<typeof CSSVariableEquipmentStatus>

type CSSPropTextOpacityCategory = ReturnType<typeof CSSVariableTextOpacityCategory>
type CSSPropTextOpacityProject = ReturnType<typeof CSSVariableTextOpacityProject>
type CSSPropTextOpacityVoltage = ReturnType<typeof CSSVariableTextOpacityVoltage>
type CSSPropTextOpacityEquipmentType = ReturnType<typeof CSSVariableTextOpacityEquipmentType>
type CSSPropTextOpacityNetworkState = ReturnType<typeof CSSVariableTextOpacityNetworkState>
type CSSPropTextOpacityEquipmentStatus = ReturnType<typeof CSSVariableTextOpacityEquipmentStatus>
type CSSPropTextOpacityOfflineRange = ReturnType<typeof CSSVariableTextOpacityOfflineRange>
export type ActivityColoringCSSProperties = Record<
  // Colors
  | CSSPropCategory
  | CSSPropProjectGantt
  | CSSPropVoltageGantt
  | CSSPropOfflineRange
  | CSSPropEquipmentType
  | CSSPropNetworkState
  | CSSPropEquipmentStatus

  // Opacity
  | CSSPropTextOpacityCategory
  | CSSPropTextOpacityProject
  | CSSPropTextOpacityVoltage
  | CSSPropTextOpacityEquipmentType
  | CSSPropTextOpacityNetworkState
  | CSSPropTextOpacityEquipmentStatus
  | CSSPropTextOpacityOfflineRange,
  string
>
